// Tiện ích thời gian dùng chung cho order-list.
//
// BE (order service) đã CHUẨN HOÁ mọi datetime trả về dạng UTC ISO ("...Z") tại
// TransformInterceptor — kể cả cột đọc thô qua getRawMany (trước đây trả chuỗi naive
// theo giờ DB server). Nhờ vậy FE KHÔNG còn phải đoán timezone của server nữa:
//   - Chuỗi có Z/offset  → parse nguyên (đã rõ tz).
//   - Chuỗi naive (nếu lọt lưới) → coi là UTC (gắn "Z") cho khớp quy ước đã chuẩn hoá.
// HIỂN THỊ: luôn format cố định theo Asia/Ho_Chi_Minh → ra đúng giờ VN, độc lập
// timezone của trình duyệt lẫn của DB server.

const HCM_TZ = "Asia/Ho_Chi_Minh";

export function parseServerDate(v: any): Date | null {
  if (v == null || v === "") return null;
  // Đã là Date (vd truyền lại từ TimeCell) → trả nguyên, không stringify.
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
  const raw = String(v).trim();
  const hasTz = raw.endsWith("Z") || /[+-]\d\d:?\d\d$/.test(raw);
  // Có Z/offset → giữ nguyên. Naive (dự phòng) → BE đã quy ước UTC → gắn "Z".
  const iso = hasTz ? raw : raw.replace(" ", "T") + "Z";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}

// Trả "DD/MM/YYYY HH:mm" theo giờ VN (GMT+7), cố định — không phụ thuộc timezone runtime.
export function formatServerDateTime(v: any): string {
  const d = parseServerDate(v);
  if (!d) return typeof v === "string" && v ? v : "—";
  const parts = new Intl.DateTimeFormat("vi-VN", {
    timeZone: HCM_TZ,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(d);
  const get = (t: string) => parts.find((p) => p.type === t)?.value || "";
  return `${get("day")}/${get("month")}/${get("year")} ${get("hour")}:${get("minute")}`;
}
